const listeners = new Map()

export const bus = {
  $on (event, callback) {
    if (!listeners.has(event)) {
      listeners.set(event, new Set())
    }
    listeners.get(event).add(callback)
  },

  $off (event, callback) {
    if (!listeners.has(event)) return

    if (callback) {
      listeners.get(event).delete(callback)
    } else {
      listeners.delete(event)
    }
  },

  $emit (event, payload) {
    if (!listeners.has(event)) return

    listeners.get(event).forEach(callback => callback(payload))
  }
}
